
import AppCompanyEdit from "@/components/company/CompanyEdit.vue";
import AppCompanyEditDossiers from "@/components/company/CompanyEditDossiers.vue";
import AppCompanyEditModules from "@/components/company/CompanyEditModules.vue";
import AppCompanyEditUsers from "@/components/company/CompanyEditUsers.vue";
import AppCompanyInvoices from "@/components/company/CompanyInvoices.vue";
import AppCompanySubscriptions from "@/components/company/CompanySubscriptions.vue";
import AppCompanyBilling from "@/components/company/CompanyBilling.vue";
import AppCompanyEditEmails from "@/components/company/CompanyEditEmails.vue";
import AppCompanyEditCrm from "@/components/company/CompanyEditCrm.vue";
import AppCompanyCtepTerminals from "@/components/company/CompanyCtepTerminals.vue";
import { Company } from "@/models/company";
import { CompanyService } from "@/services/company-service";
import Vue from "vue";
import { resetTitle } from "@/utils/title";


export default Vue.extend({
	data() {
		return {
			company: new Company(),
			currentTab: 0,
			ready: false
		};
	},
	watch: {
		"$route.query.currentTab": {
			immediate: true,
			handler(){
				this.currentTab = parseInt(this.$route.query.currentTab as string || "0");
			}
		}
	},
	async created(){
		//if current tab is set go to and remove querry from url
		if (this.$route.query.currentTab) {
			this.currentTab = parseInt(this.$route.query.currentTab[0] || "0");
			let query = Object.assign({}, this.$route.query);
			delete query.currentTab;
			this.$router.replace({ query });
		}
		this.company = await CompanyService.getCompany(parseInt(this.$route.params.id));
		this.ready = true;
	},
	destroyed(){
		resetTitle();
	},
	components: {
		AppCompanyEdit,
		AppCompanyEditUsers,
		AppCompanyEditModules,
		AppCompanyEditDossiers,
		AppCompanyInvoices,
		AppCompanySubscriptions,
		AppCompanyBilling,
		AppCompanyEditEmails,
		AppCompanyEditCrm,
		AppCompanyCtepTerminals
	}
});
